export default "__VITE_PUBLIC_ASSET__45b94654__"